import React from 'react';
import './Works.css';

import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";

import { AiFillGithub } from 'react-icons/ai';
import { CgWebsite } from 'react-icons/cg';

const Works = () => {
    return(
        <div className="works">
            <h2>AndroidDeliveryFoodApp <a href="https://github.com/MyNameIsDVL/delivery_android_food_app/tree/master"><AiFillGithub /></a></h2>
            <div className="works-grid">
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/android2.jpg" />
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/android3.jpg" />
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/android1.jpg" />
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/android4.jpg" />
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/android5.jpg" />
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/android6.jpg" />
                    </div>
                </AnimationOnScroll>
            </div>
            <h2>ReactDeliveryFoodApp <a href="https://github.com/MyNameIsDVL/delivery/tree/master"><AiFillGithub /></a><a href="https://mynameisdvl.github.io/delivery/"><CgWebsite /></a></h2>
            <div className="works-grid-react">
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/delivery1.png" />
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/delivery2.png" />
                    </div>
                </AnimationOnScroll>
            </div>
            <h2>Neu tech - dla webtec <a href="https://neu.com.pl/"><CgWebsite /></a></h2>
            <div className="works-grid-neu">
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/neu.png" />
                    </div>
                </AnimationOnScroll>
            </div>
            <h2>Kdwu - dla Dyckerhoff <a href="https://kdwu.pl/"><CgWebsite /></a></h2>
            <div className="works-grid-neu">
                <AnimationOnScroll animateIn="animate__fadeIn" className="works-card">
                    <div className="works-img">
                        <img alt="work" src="/assets/images/kdwu.png" />
                    </div>
                </AnimationOnScroll>
            </div>
            <div className="btndiv-container">
                <a className="btngithub" href="https://github.com/MyNameIsDVL?tab=repositories" >Więcej na moim github.com</a>
            </div>
        </div>
    );
}

export default Works;